import React , {useContext} from "react";
import './Experience.css'
import CardEducation from "../cardEducation/CardEducation";
import { themeContext } from "../../Context";
import {motion} from 'framer-motion';
import { useTranslation } from "react-i18next"; //translator
//import Waveline from "./Waveline.js";

const Experience = () => {
    const [t] = useTranslation("global");

    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;

    return(
        <div className="experience" id="Experience">
            <div className="about">
                <span>{t("Experience.title.1")}</span>
                <span style={{color : darkMode? 'white' : ''}}> {t("Experience.title.2")}</span>
                <span>{t("Experience.title.3")}</span>


                <span  style={{color : darkMode? '#ffcd6a' : ''}}>
                
                  {t("Experience.description.1")}
                <br/>
                  {t("Experience.description.2")}
                <br/>
                  {t("Experience.description.3")}
                <br/>
                  {t("Experience.description.4")}
                </span>

                <div className="blur e-blur2" style={{background:"var(--purple)"}} ></div>
                {/* <Waveline/> */}
                 <div className="linea">
                    <svg  /* style={{left:'-200px', top:'-20px'}} */
                     viewBox="0 0 1440 363"  fill="none"  xmlns="http://www.w3.org/2000/svg">
                     <motion.path
                        initial={{ pathLength: 0, pathOffset: 1 }}
                        animate={{ pathLength: 1, pathOffset: 0 }}
                        transition={{ repeat : 10 ,duration: 5}}
                        d="M1440 27.4774C1352.73 19.8184 1122.41 49.0556 899.331 227.276C620.48 450.052 354.282 355.647 170.328 185.318C23.165 49.0556 -4.21721 8.32998 0.487081 5"
                        stroke="#ffa500"
                        strokeOpacity="0.5"
                        strokeWidth="3"
                      />
                    </svg>
                 </div>


            </div>



         {/* ---------------------------------right Side */}
            <div className="cardsEducation">

                         {/*  -------------------------- first card */}
                         <div style={{left: '6rem'}}>
                            <CardEducation
                            study = {t("Experience.cardsEd.dfs.1")}
                            name = {t("Experience.cardsEd.dfs.2")}
                            detail = {t("Experience.cardsEd.dfs.3")}
                            >
                            </CardEducation>
                        </div>

                            {/*  -------------------------- sECOND card */}
                        <div style={{left: '6rem', top: '18rem'}}>
                            <CardEducation
                            study = {t("Experience.cardsEd.id.1")}
                            name = {t("Experience.cardsEd.id.2")}
                            detail = {t("Experience.cardsEd.id.3")}
                            >
                            </CardEducation>
                        </div>

                     {/*  -------------------------- third card */}
                         <div style={{left: '6rem', top: '22rem'}}>
                            <CardEducation
                            study = {t("Experience.cardsEd.ss.1")}
                            name = {t("Experience.cardsEd.ss.2")}
                            detail = {t("Experience.cardsEd.ss.3")}
                            >
                            </CardEducation>
                        </div>
               
                        <div className="blur e-blur3" style={{background:"var(--orange)"}} ></div>
                        <div className="blur e-blur4" style={{background: "var(--yellowblur)"}} ></div>
                       
                        
                       
                       
                        


            </div>
            
         {/* ---------------------------------right Side */}
        </div>
    );
};

export default Experience;
